import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const ProjectBasicInfo = ({ 
  formData, 
  onFieldChange, 
  activeLanguage, 
  errors = {},
  categories = []
}) => {
  const statusOptions = [
    { value: 'planned', label: 'مخطط', description: 'المشروع في مرحلة التخطيط' },
    { value: 'ongoing', label: 'جاري', description: 'المشروع قيد التنفيذ' },
    { value: 'completed', label: 'مكتمل', description: 'تم إنجاز المشروع' },
    { value: 'paused', label: 'متوقف', description: 'المشروع متوقف مؤقتاً' },
    { value: 'cancelled', label: 'ملغي', description: 'تم إلغاء المشروع' }
  ];

  const priorityOptions = [
    { value: 'low', label: 'منخفضة', description: 'أولوية منخفضة' },
    { value: 'medium', label: 'متوسطة', description: 'أولوية متوسطة' },
    { value: 'high', label: 'عالية', description: 'أولوية عالية' },
    { value: 'urgent', label: 'عاجلة', description: 'أولوية عاجلة' }
  ];

  const getFieldValue = (fieldName) => {
    if (fieldName === 'title' || fieldName === 'description') {
      return formData?.[fieldName]?.[activeLanguage] || '';
    }
    return formData?.[fieldName] || '';
  };

  const handleFieldChange = (fieldName, value) => {
    if (fieldName === 'title' || fieldName === 'description') {
      onFieldChange(fieldName, {
        ...formData?.[fieldName],
        [activeLanguage]: value
      });
    } else {
      onFieldChange(fieldName, value);
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="Info" size={18} className="text-primary" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground font-arabic">
            المعلومات الأساسية
          </h3>
          <p className="text-sm text-muted-foreground font-caption">
            أدخل التفاصيل الأساسية للمشروع
          </p>
        </div>
      </div>
      <div className="space-y-6">
        {/* Project Title */}
        <div>
          <Input
            label={`عنوان المشروع (${activeLanguage?.toUpperCase()})`}
            type="text"
            placeholder={activeLanguage === 'ar' ? 'أدخل عنوان المشروع بالعربية' : 
                        activeLanguage === 'en'? 'Enter project title in English' : 'Proje başlığını Türkçe girin'}
            value={getFieldValue('title')}
            onChange={(e) => handleFieldChange('title', e?.target?.value)}
            error={errors?.title}
            required
            className="mb-4"
          />
          
          {/* Character Count */}
          <div className="flex justify-between text-xs text-muted-foreground">
            <span>الحد الأدنى: 5 أحرف</span>
            <span>{getFieldValue('title')?.length}/100</span>
          </div>
        </div>

        {/* Project Status and Priority */}
        <div>
          <Select
            label="حالة المشروع"
            description="اختر الحالة الحالية للمشروع"
            options={statusOptions}
            value={getFieldValue('status')}
            onChange={(value) => handleFieldChange('status', value)}
            error={errors?.status}
            required
            className="mb-4"
          />

          {/* <Select
            label="أولوية المشروع"
            description="حدد مستوى أولوية المشروع"
            options={priorityOptions}
            value={getFieldValue('priority')}
            onChange={(value) => handleFieldChange('priority', value)}
            error={errors?.priority}
            className="mb-4"
          /> */}
        </div>

        {/* Category and Member Count */}
        <div>
          <Select
            label="فئة المشروع"
            description="اختر الفئة المناسبة للمشروع"
            options={categories}
            value={getFieldValue('category')}
            onChange={(value) => handleFieldChange('category', value)}
            error={errors?.category}
            searchable
            className="mb-4"
          />

          {/* <Input
            label="عدد الأعضاء المشاركين"
            type="number"
            placeholder="أدخل عدد الأعضاء"
            value={getFieldValue('memberCount')}
            onChange={(e) => handleFieldChange('memberCount', parseInt(e?.target?.value) || 0)}
            error={errors?.memberCount}
            min="1"
            max="1000"
            className="mb-4"
          /> */}
        </div>

        {/* Budget Information */}
        {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Input
            label="الميزانية المخططة (ليرة سورية)"
            type="number"
            placeholder="0"
            value={getFieldValue('budget')}
            onChange={(e) => handleFieldChange('budget', parseFloat(e?.target?.value) || 0)}
            error={errors?.budget}
            min="0"
            className="mb-4"
          />

          <Input
            label="الميزانية المستخدمة (ليرة سورية)"
            type="number"
            placeholder="0"
            value={getFieldValue('usedBudget')}
            onChange={(e) => handleFieldChange('usedBudget', parseFloat(e?.target?.value) || 0)}
            error={errors?.usedBudget}
            min="0"
            className="mb-4"
          />
        </div> */}

        {/* Project Tags */}
        {/* <div>
          <Input
            label="علامات المشروع"
            type="text"
            placeholder="أدخل العلامات مفصولة بفواصل (مثال: تعليم، تطوير، مجتمع)"
            value={getFieldValue('tags')}
            onChange={(e) => handleFieldChange('tags', e?.target?.value)}
            error={errors?.tags}
            description="استخدم الفواصل للفصل بين العلامات"
            className="mb-4"
          />
        </div> */}
      </div>
    </div>
  );
};

export default ProjectBasicInfo;